import { FeatureFlagEnum } from '@shared/enums/feature-flag.enum';
import { EnvironmentModel } from '@shared/models/environment.model';

class EnvironmentImpl implements EnvironmentModel {
  production = false;
  sentryDSN = 'https://e8c4edee1f9c4bfb959ec3031090a777@sentry.io/1471235';

  featureConfig = {
    [FeatureFlagEnum.CreditReportClientTabs]: true,
    [FeatureFlagEnum.CreditReportSettings]: true,
    [FeatureFlagEnum.PreCompletions]: true,
    [FeatureFlagEnum.GlobalSearch]: true,
    [FeatureFlagEnum.EmailPreviewer]: true,
    [FeatureFlagEnum.MabTheme]: true,
    [FeatureFlagEnum.ActivityLog]: true,
  };

  googleCloudPlatformApiKey = 'AIzaSyCEw-HdVyu1zDW9oLjM56yuTeyY3EvTeYU';
  maintenanceUrl = 'https://storage.googleapis.com/dashlydev-ui-apps-config/config.json';

  urls = {
    clientPortalUrl: 'https://my.dashly-dev.com',
    adviserPortalUrl: 'https://port.dashly-dev.com',
    apiUrl: 'https://api.dashly-dev.com',
  };

  companyIds = {
    dashlyCompanyId: '1',
  };

  networkIds = { mabId: '1' };
}

export const environment = new EnvironmentImpl();
